import { render, staticRenderFns } from "./CountBox.vue?vue&type=template&id=f0bf3528&scoped=true"
import script from "./CountBox.vue?vue&type=script&lang=js"
export * from "./CountBox.vue?vue&type=script&lang=js"
import style0 from "./CountBox.vue?vue&type=style&index=0&id=f0bf3528&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0bf3528",
  null
  
)

export default component.exports